import { WrapperTitle } from './PageBox.styles';

type PageBoxTitleProps = {
	title: string;
};

export const PageBoxTitle = ({ title }: PageBoxTitleProps): JSX.Element => (
	<WrapperTitle>{title}</WrapperTitle>
);
